









import { Component } from 'vue-property-decorator'
import SelectInput from '@/components/common/inputs/SelectInput.vue'
import * as ruleNames from '@/components/common/inputs/constants/ruleNames'

export type Option =
  | {
      text: string | number
      value: string | number
    }
  | string
  | number

@Component
export default class ScheduleTimeSelectInput extends SelectInput {
  supportedRules: Array<string> = [
    ruleNames.REQUIRED,
    ruleNames.END_GREATER_THAN_START
  ]
}
